// Utilitaires monétaires — TOUT montant en DT est quantifié au millime (3 décimales).
// Utiliser round3 sur chaque valeur calculée AVANT de l'envoyer au backend,
// et formatDT pour l'affichage.

export function round3(n) {
  return Math.round(((Number(n) || 0) + Number.EPSILON) * 1000) / 1000;
}

export function formatDT(amount) {
  return `${round3(amount).toFixed(3)} DT`;
}
